import React from 'react';

import cx from 'classnames';

import { FontAwesomeIcon } from 'components/shared/Icon/FontAwesome';
import { Label } from 'components/shared/Label';
import { getLabelColor } from 'components/shared/Label/utils';
import { EBlockType, IBlock } from 'detailsv2/__blocks';
import { getBlockAnchorId } from 'utils/itineraries/functions/utils';

import { getPrefix } from '../../../../utils';
import { useBlockContext } from '../../Block/context';
import { useReadonlyBlockClick } from '../functions';
import { ChildrenBlocksContent } from './ChildrenBlocksContent';
import s from './index.module.css';

export const TripEventBlock = () => {
  const { block } = useBlockContext<IBlock<EBlockType.TripEvent>>();
  const handleClick = useReadonlyBlockClick();

  return (
    <div className={s.wrapper} id={getBlockAnchorId(block.id)}>
      {/* Title & Icon */}
      <div className={s.titleWrapper}>
        {/* Icon */}
        <div className={cx(s.icon, getPrefix('trip-event-icon'))}>
          <FontAwesomeIcon className={block.data.icon} />
        </div>

        {/* Title */}
        <div className={cx(s.container, s.titleContainer)}>
          <div className={cx(s.title, getPrefix('trip-event-title'))} onClick={handleClick}>
            <span data-block>{block.data.title}</span>
            {block.data.badge && (
              <Label
                color={getLabelColor(block.data.badgeColor)}
                text={block.data.badge}
                className={cx(s.alternateLabel, getPrefix('trip-event-label'))}
              />
            )}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className={s.container}>
        <ChildrenBlocksContent showAloneAddNewContent={false} />
      </div>
    </div>
  );
};
